// extracted by mini-css-extract-plugin
export var application = "main_layout-module--application--50aed";